<template>
  <div class="uploaddata">
    <!-- <el-button>DTR上传</el-button> -->
    <div class="content">
      <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" inlineMessage status-icon :model="formCase">
        <el-form-item label="经销店名称" prop="dealerName">
          <el-input disabled v-model="formCase.dealerName"></el-input>
        </el-form-item>
        <el-form-item label="服务委托书编号" prop="caseNo">
          <el-input readonly v-model="formCase.caseNo"></el-input>
        </el-form-item>
        <el-form-item label="VIN" prop="vin">
          <el-input readonly v-model="formCase.vin"></el-input>
        </el-form-item>
        <el-form-item label="上传人" prop="uploadUserName">
          <el-input readonly v-model="formCase.uploadUserName"></el-input>
        </el-form-item>
        <el-form-item label="上传时间" prop="uploadDatetime">
          <el-input readonly v-model="formCase.uploadDatetime"></el-input>
        </el-form-item>
        <div  v-if="formCase.attaGroup">
        <div class="" v-for="it in Object.keys(formCase.attaGroup)">
          <el-form-item label="" prop="title">
            <span style="margin-right: 20px; width: 100px;float: left;">{{it}}</span>
            <!-- <el-button type="primary" size="mini" @click="confirmUserFn(it)">全部承认</el-button> -->
          </el-form-item>
          <el-row class="row-bg">
            <el-col :span="10" style="margin-right: 6%;position:relative" v-for="(item, index) in formCase.attaGroup[it]" :key="index">
              <img :src="item.url" preview="2" style="width: 100%" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0">
              <el-row style="height:180px; width:100%;" v-else-if="item.type&&item.type.indexOf('video')>=0">
                <div style="position:absolute;height:160px;width:100%;" >
                  <video :src="item.url" style="width: 100%;object-fit:fill;height: 100%;" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
                  <a style="position:relative;top:0;right:-100px;z-index:999;" :href="item.url" download>下载</a>
                </div>
              </el-row>
              <div style="width:100%;height:100%;" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i><a :href="'api/'+item.url" style="position:absolute;width:100%;height:100%;top:0;left:0" alt="" download></a></div>

              <div v-if="item.dtrStatus==='被打回'">
                附件状态： 退回
              </div>
            </el-col>
          </el-row>
        </div>
        </div>
        <!-- <el-row class="row-bg" v-if="formCase.status==='通过'&&fileList.length>0">
          <el-col :span="24">
            附件 :
          </el-col>
          <el-col :span="10" style="margin-right: 6%;position:relative" v-for="(item, index) in fileList" :key="index">
            <img style="width: 100%;" :src="item.url" preview="2" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0">
            <el-row style="height:180px; width:100%;" v-else-if="item.type&&item.type.indexOf('video')>=0">
              <div style="position:absolute;height:160px;width:100%;" >
                <video style="width: 100%;height: 100%;" :src="item.url" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
                <a style="position:relative;top:0;right:-100px;z-index:999;" :href="item.url" download>下载</a>
              </div>
            </el-row>
            <div style="width:100%;height:100%;" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i><a :href="'api/'+item.url" style="position:absolute;width:100%;height:100%;top:0;left:0" alt="" download></a></div>
          </el-col>
        </el-row> -->
        <!-- <el-form-item label="附件" v-if="users.dlrAdvanceUser">
          <Upload url="api/file/Upload" :caseNo="formCase.caseNo" :vin="formCase.vin" :attac="formCase.attachmentIds" :fileList="fileList" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item> -->
        <el-form-item label="附件(视频)" v-if="formCase.status!=='通过'&&formCase.status!=='已提交'">
          <Upload url="api/file/Upload" :flag="flags" type="video" :caseNo="formCase.caseNo" :attac="formCase.attachmentIds" :fileList="fileList.filter(item=> item.type&&item.type.indexOf('video')>=0)" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item>
        <el-form-item label="附件(照片)" v-if="formCase.status!=='通过'&&formCase.status!=='已提交'">
          <Upload url="api/file/Upload" :flag="flags" type="image" :caseNo="formCase.caseNo" :attac="formCase.attachmentIds" :fileList="fileList.filter(item=> item.type&&item.type.indexOf('image')>=0)" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/javascript">
import Upload from './Upload'
import axios from '@/utils/api.request'
import { Toast, MessageBox } from 'mint-ui'
import {getImg} from '@/api/case'
import {getDetailData} from '@/api/quality'
import Global from '@/config/global.js'
export default{
  components: { Upload },
  data() {
    return {
      rules: {},
      formCase: {},
      fileList: [],
      fileList1: [],
      fileList2: [],
      attachmentIdss: [],
      sub: false,
      ticketNum: '',
      vin: '',
      users: {},
      flags: false
    }
  },
  created() {
    if(this.$route.params){
      this.ticketNum = this.$route.params.ticketNum
      this.vin = this.$route.params.vin
    }
    this.users = JSON.parse(localStorage.getItem("user"))
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.flags = true
    } else {
       this.flags = false
    }
    this.getData()
  },
  methods: {
    getData() {
      getDetailData({caseNo:this.ticketNum, vin:this.vin}).then(res => {
        if(res.data.success){
          this.formCase = res.data.data
          if(this.formCase.attaGroup&&Object.keys(this.formCase.attaGroup)){
            let groupList = Object.keys(this.formCase.attaGroup)
            groupList.forEach((it) => {
              let arr = []
              this.formCase.attaGroup[it].forEach((v, i) => {
                let json = {
                  id: v.id,
                  name: v.rawName,
                  url: v.url,
                  type: v.mime,
                  dtrStatus: v.dtrStatus
                }
                arr.push(json)
                if(v.mime.indexOf('image')>=0){
                  getImg(v.url).then(resp=>{
                    var mimeType = v.mime.toLowerCase();
                    var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                    arr[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                  })
                }else if(v.mime.indexOf('video')>=0){
                   arr[i].url = Global.server_api + v.url;
                }

              })
              this.formCase.attaGroup[it] = arr
            })

          }
          if(this.formCase.attaList){
            this.formCase.attaList.forEach((v, i) => {
              let json = {
                id: v.id,
                name: v.rawName,
                url: v.url,
                type: v.mime,
                dtrStatus: v.dtrStatus
              }
              this.fileList.push(json)
              if(v.mime.indexOf('image')>=0){
                getImg(v.url).then(resp=>{
                  var mimeType = v.mime.toLowerCase();
                  var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                  this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                })
              }else if(v.mime.indexOf('video')>=0){
                 this.fileList[i].url = Global.server_api + v.url;
              }

            })
          }
          console.log(this.fileList)
          console.log(this.fileList.filter(item=> item.type&&item.type.indexOf('video')>=0))
          this.fileList1 = this.fileList.filter(item=> item.type&&item.type.indexOf('video')>=0)
          this.fileList2 = this.fileList.filter(item=> item.type&&item.type.indexOf('image')>=0)
          Toast({
            message: '获取案件成功',
            iconClass: 'icon el-icon-check'
          })
        }else{
          // this.$message({
          //   type: 'error',
          //   message: res.data.msg
          // })
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    subs(data) {
      this.sub = data
    },
    changeAttachs(data) {
        console.log(data)
      this.attachmentIdss = data;
    },
    getSign() {
      let url = location.href.split('#')[0]
    },
  }
}
</script>

<style scoped>
.uploaddata{
  background: #fff;
  text-align: left;
  padding: 0.3rem;
  position: relative;
  top: -100px;
  z-index: 99;
}
</style>
